import { Component, Input, OnInit } from '@angular/core';
import { INavbarTab } from './navbar-tab.types';
import { ActiveTabService } from '../../../active-tab.service';

@Component({
  selector: 'nx-navbar-tab',
  templateUrl: './navbar-tab.component.html',
  styleUrls: ['./navbar-tab.component.scss'],
})
export class NavbarTabComponent implements INavbarTab, OnInit {
  constructor(private tabService: ActiveTabService) {}

  // REQUIRED INPUTS
  @Input() tabUrl!: string;

  // PROPERTIES
  isActive = false;

  // HOOKS
  ngOnInit(): void {
    this.isActive = this.tabService.activeTab.fields.url === this.tabUrl;
  }
}
